<template>
	<Popup v-model="selfDisplay" title="更改检测信息" @confirmClick="handleConfirmClick">
		<div v-loading="loading" style="padding: 15px">
			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">
					<span style="color: #f00">*</span>
					订单状态
				</span>
				<div class="b_checkbox_group">
					<el-select v-model="status" placeholder="请选择" style="width: 100%">
						<el-option v-for="v in statusList" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
			</div>
			<template v-if="status >= 3">
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						发货公司
					</span>
					<el-input v-model="company" placeholder="发货公司"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="companyTip">
						<i class="b_icon"></i>
						请输入发货公司
					</template>
				</div>

				<div class="base_form_row">
					<span class="b_label">
						<span style="color: #f00">*</span>
						快递单号
					</span>
					<el-input v-model="number" placeholder="快递单号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px">
					<template v-if="numberTip">
						<i class="b_icon"></i>
						请输入快递单号
					</template>
				</div>
			</template>
		</div>
	</Popup>
</template>

<script>
import Api from '../../../../../api/index.js';
export default {
	model: {
		prop: 'display',
		event: 'changeDisplay'
	},
	props: {
		display: Boolean,
		orderId: {
			type: String,
			default: ''
		},
		obj: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	mounted() {
		this.display && (this.selfDisplay = true);
	},
	data() {
		return {
			loading: false,
			selfDisplay: false,

			company: '',
			number: '',
			companyTip: false,
			numberTip: false,

			status: 1,
			statusList: [
				{
					id: 1,
					name: '未发货'
				},
				{
					id: 2,
					name: '制作中'
				},
				{
					id: 3,
					name: '已发货'
				},
				{
					id: 4,
					name: '已收货'
				}
			]
		};
	},
	methods: {
		// 点击确定
		handleConfirmClick() {
			if (this.status >= 3) {
				if (!this.company.trim()) {
					this.companyTip = true;
					return false;
				} else {
					this.companyTip = false;
				}
				if (!this.number.trim()) {
					this.numberTip = true;
					return false;
				} else {
					this.numberTip = false;
				}
			}

			this.send();
		},
		// 发货
		send() {
			const that = this;
			that.loading = true;
			let requestData = {
				orderId: that.orderId,
				kdCodeReturn: that.company,
				orderNoReturn: that.number
			};
			Api.lensOrderUpdate({
				coinDetailId: this.obj.coinDetailId,
				orderStatus: this.status
			}).then(
				(res) => {
					if (res.data.success) {
						if (this.status >= 3) {
							Api.lensSend(requestData);
						}
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
			
		}
	},
	watch: {
		display(newVal) {
			this.selfDisplay = newVal;
		},
		selfDisplay(newVal) {
			this.$emit('changeDisplay', newVal);
			if (newVal) {
				this.status = Number(this.obj.orderStatus)||1;
				this.loading = false;
				// this.company = '';
				// this.number = '';
				this.companyTip = false;
				this.numberTip = false;
				this.company = this.obj.kdCodeReturn;
				this.number = this.obj.orderNoReturn;
			}
		}
	}
};
</script>

<style></style>
